import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCross24 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m12 13.414 4.543 4.543.707-.707.707-.707L13.414 12l4.543-4.543-1.414-1.414L12 10.586 7.457 6.043 6.043 7.457 10.586 12l-4.543 4.543 1.414 1.414z"
	})
});
const ForwardRef = forwardRef(SvgIconCross24);
export default ForwardRef;
